import React from "react";
import { Container, Grid, Typography } from "@mui/material";

interface Props {
  feedback:
    | "startup"
    | "login"
    | "handleRedirect"
    | "logout"
    | "acquireToken"
    | "ssoSilent"
}

interface FeedbackMessageProps {
  message: string
}

const FeedbackMessage = ({ message }: FeedbackMessageProps) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh" }}
    >
      <Grid item>
        <Typography variant="h2" align="center">{message}</Typography>
      </Grid>
    </Grid>
  );
};


export default function Feedback({ feedback }: Props) {
  return (
    <Container>
      {feedback === "startup"
        ? <FeedbackMessage message="Loading app..." />
        : feedback === "login"
          ? <FeedbackMessage message="Trying to sign in..." />
          : feedback === "handleRedirect"
            ? <FeedbackMessage message="Redirecting to the app..." />
            : feedback === "logout"
              ? <FeedbackMessage message="Logging out..." />
              : feedback === "acquireToken"
                ? <FeedbackMessage message="Acquiring token..." />
                : feedback === "ssoSilent"
                  ? <FeedbackMessage message="Silent login..." />
                  : feedback}
    </Container>
  );
}

